import { render } from "./SiteConfigSetting.vue?vue&type=template&id=fb07fb16&scoped=true"
import script from "./SiteConfigSetting.vue?vue&type=script&lang=js"
export * from "./SiteConfigSetting.vue?vue&type=script&lang=js"

import "./SiteConfigSetting.vue?vue&type=style&index=0&id=fb07fb16&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/JEEducation.Student_STAGING/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb07fb16"]])

export default __exports__